import ExternalLinkIcon from '@mui/icons-material/OpenInNew';
import PropTypes from 'prop-types';

import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';

function EnterpriseLink({ name, url }) {
  return (
    <Link
      href={url}
      underline="none"
      target="_blank"
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {name}
        <ExternalLinkIcon fontSize="small" />
      </Stack>
    </Link>
  );
}

EnterpriseLink.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string.isRequired
};

export default EnterpriseLink;
